import { render, staticRenderFns } from "./UserLandlordsList.vue?vue&type=template&id=bca708a8&scoped=true&"
import script from "./UserLandlordsList.vue?vue&type=script&lang=js&"
export * from "./UserLandlordsList.vue?vue&type=script&lang=js&"
import style0 from "./UserLandlordsList.vue?vue&type=style&index=0&id=bca708a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca708a8",
  null
  
)

export default component.exports